module.exports = __webpack_public_path__ + "assets/img/securitiesSolutions-news-bg.35d870bf.png";